export default "__VITE_PUBLIC_ASSET__cff8fcec__"